package info.rezident.app.ui.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import info.rezident.app.ui.theme.AppTheme
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

@Composable
fun SaveYourResultsSection(
    modifier: Modifier = Modifier,
    isCompleted: Boolean = false,
    onMyProfileClick: () -> Unit,
) {
    Column(
        modifier = modifier
            .fillMaxWidth()
            .backgroundColor(Color.transparent)
            .borderRadius(AppTheme.shapes.mediumRound)
            .border(1.px, style = LineStyle.Solid, color = AppTheme.colors.accent)
            .padding(24.px)
    ) {
        Row(
            verticalAlignment = Alignment.Top,
            horizontalArrangement = Arrangement.spacedBy(8.px),
            modifier = Modifier.weight(1f).padding(bottom = if (isCompleted) 8.px else 16.px)
        ) {
            SpanText(
                text = if (isCompleted) "Recomandări Salvate" else "Salvează Recomandările",
                modifier = AppTheme.typography.h2.toModifier()
                    .color(AppTheme.colors.text)
            )
        }

        if (!isCompleted) {
            SpanText(
                text = "Pentru a putea vizualiza recomandările tale oricând, sau a le primi pe mail.",
                modifier = AppTheme.typography.body1.toModifier()
                    .margin(bottom = 30.px)
                    .color(AppTheme.colors.textSecondary)
            )
        } else {
            SpanText(
                text = "Recomandările tale sunt salvate și le poți accesa oricând din profilul tău.",
                modifier = AppTheme.typography.body1.toModifier()
                    .color(AppTheme.colors.text)
                    .margin(top = 8.px, bottom = 24.px)
            )
        }

        Button(
            onClick = { onMyProfileClick() },
            modifier = Modifier
                .fillMaxWidth()
                .backgroundColor(Color.transparent)
                .padding(4.px)
                .border(1.px, LineStyle.Solid, color = AppTheme.colors.text)
                .borderRadius(AppTheme.shapes.mediumRound),
        ) {
            SpanText(
                text = "Profilul meu",
                modifier = AppTheme.typography.body1Medium.toModifier()
                    .color(AppTheme.colors.text)
            )
        }
    }
}

@Composable
fun ViewYourAnswersSection(
    modifier: Modifier = Modifier,
    onViewAnswersClick: () -> Unit,
) {
    Column(
        modifier = modifier
            .fillMaxWidth()
            .backgroundColor(Color.transparent)
            .borderRadius(AppTheme.shapes.mediumRound)
            .border(1.px, style = LineStyle.Solid, color = AppTheme.colors.accent)
            .padding(24.px)
    ) {
        Row(
            verticalAlignment = Alignment.Top,
            horizontalArrangement = Arrangement.spacedBy(8.px),
            modifier = Modifier.weight(1f).padding(bottom = 16.px)
        ) {
            SpanText(
                text = "Răspunsurile Tale",
                modifier = AppTheme.typography.h2.toModifier()
                    .color(AppTheme.colors.text)
            )
        }

        SpanText(
            text = "Toate răspunsurile tale la Quiz-ul de Orientare au influențat recomandările pe care le-ai primit.",
            modifier = AppTheme.typography.body1.toModifier()
                .margin(bottom = 30.px)
                .color(AppTheme.colors.textSecondary)
        )

        Button(
            onClick = { onViewAnswersClick() },
            modifier = Modifier
                .fillMaxWidth()
                .backgroundColor(Color.transparent)
                .padding(4.px)
                .border(1.px, LineStyle.Solid, color = AppTheme.colors.text)
                .borderRadius(AppTheme.shapes.mediumRound),
        ) {
            SpanText(
                text = "Vezi răspunsurile",
                modifier = AppTheme.typography.body1Medium.toModifier()
                    .color(AppTheme.colors.text)
            )
        }
    }
}
